// extracted by mini-css-extract-plugin
module.exports = {"body":"Home2Body_body__BruOo","row":"Home2Body_row__l9K1y"};